// extracted by mini-css-extract-plugin
export default {"picture":"picture-module--picture--hfZEM"};